<template>
  <div class="col-12 my-2">
    <div class="row">
      <div class="col-lg-10 col-12">
        <h6>اشتراک های
          <span class="font-weight-bolder">
        {{ findAttributeOnSiteInfo('site_name')[0] }}
        </span>
        </h6>
      </div>
      <div class="col-lg-2 col-12 text-left">
        <m-a :href='{name:"ModulesList"}'>
          <button class="btn btn-primary rounded-pill">ماژول های من</button>
        </m-a>

        <b-button pill v-b-toggle.filters class="mx-1" variant="primary">جست وجو</b-button>

      </div>
    </div>

    <b-collapse id="filters" class="mt-2">
      <div class="row">
        <div class="col-lg-4 align-self-end">
          <search-filter1 class="d-inline" @search="setSearch" ref="searchComponent"/>

        </div>
        <div class="col-lg-2 align-self-end">
          <b-button class="d-inline"
                    @click="triggerSearch"
                    variant="primary"

          >
            جستجو
          </b-button>

        </div>

      </div>
    </b-collapse>


    <div class="col-12">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">نام ماژول</th>
          <th scope="col">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(product,index) in products" :key="index">
          <th dir="ltr">{{ product.name }}</th>
          <th>
            <template v-if="userHaveSubscriptionBefore(product)">
              <button class="btn btn-success rounded-pill">نصب شده
              </button>
            </template>
            <template v-else>
              <button class="btn btn-primary rounded-pill" :disabled="false" :id="`product-buy-button-${product.id}`"
                      v-b-modal="`product-buy-modal-${product.id}`">
                خرید
              </button>

              <b-modal :id="`product-buy-modal-${product.id}`" hide-footer size="lg">
                <div dir="rtl" class="text-right">

                  <h4>{{ product.name }}</h4>

                  <gate-manager1 request-mode="service" @selected_wallet="setSelectedWallet" v-model="payment_gate"/>

                  <div class="text-center my-4">
                    <button class="w-75 btn btn-primary" :id="`product-buy-modal-button-${product.id}`" type="submit"
                            @click="newSubscription(product)">پرداخت
                    </button>
                  </div>

                </div>

              </b-modal>

            </template>


          </th>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12">
      <pagination400 :meta="pagination" :on-change-page="loadProducts" />
    </div>


  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";
import SearchFilter1 from "@/plugin/components/dashboard/Filters/Search/SearchFilter1.vue";
import GateManager1 from "@/plugin/components/dashboard/Gate/GateManager/GateManager1.vue";
import Pagination400 from "@/plugin/miw-components/pagination/Pagination-400.vue";

export default {
  name: "ModuleInstall",
  components: {Pagination400, GateManager1, SearchFilter1},
  data() {
    return {
      products: {},
      pagination: {},
      user_subscriptions: [],
      payment_gate: null,
      wallet_id: null
    }
  },
  computed: {
    ...mapGetters({
      userId: "User/getUserId"
    })
  },
  methods: {
    findAttributeOnSiteInfo,
    async loadProducts(page = 1) {
      let form = {
        page: page
      }
      let req = await this.$store.dispatch('DashboardSubscription/getProductsWithSubscription', form)
      let data = req.data.data
      this.products = data.data
      this.pagination = data.meta
      this.user_subscriptions = data.user_subscriptions
    },
    userHaveSubscriptionBefore(product) {
      let userSubscriptions = this.user_subscriptions
      let checker = false
      product.subscriptions.forEach(subscription => {
        if (userSubscriptions.indexOf(subscription.id) > -1) {
          checker = true
        }
      })
      return checker
    },
    setSelectedWallet(value) {
      this.wallet_id = value
    },
    setSearch(words) {
      this.$store.commit('DashboardSubscription/setFilters', {key: 'search', value: words.searchWords})
      this.loadProducts()
    },
    triggerSearch() {
      const searchWords = this.$refs.searchComponent.searchWords || ''; // مقدار فیلد جستجو
      this.setSearch({searchWords});
    },
    async newSubscription(product) {
      let form = {
        product_id: product.id,
        user_id: this.userId,
        gateway: this.payment_gate,
        wallet_id: this.wallet_id,
      }

      let buyButton = document.getElementById(`product-buy-button-${product.id}`)
      let modalButton = document.getElementById(`product-buy-modal-button-${product.id}`)
      buyButton.setAttribute('disabled', 'disabled')
      modalButton.setAttribute('disabled', 'disabled')

      this.$store.dispatch('DashboardSubscription/projectNewSubscription', form)
          .catch(err => {
            buyButton.removeAttribute('disabled')
            modalButton.removeAttribute('disabled')
          })
          .then(res => {
            window.location.href = res.data.data.payment_url
            buyButton.setAttribute('disabled')
            modalButton.setAttribute('disabled')
          })

    }
  },
  mounted() {
    this.loadProducts()
  }
}
</script>

<style scoped>

</style>